import { useCartActions, useCartState } from "@app/_context";
import type { ChangeEvent, FormEvent } from "react";
import { useMemo, useRef, useState } from "react";

export default function useEurobonus(defaultValue = "") {
  const { cart } = useCartState();
  const { updateCartMetadata } = useCartActions();
  const [eurobonusNumber, setEurobonusNumber] = useState(
    cart?.meta?.EUROBONUS_NUMBER || defaultValue,
  );
  const inputRef = useRef<HTMLInputElement>(null);

  const isValidEurobonusNumber = useMemo(() => {
    return (cart?.meta?.EUROBONUS_NUMBER || "").length > 0;
  }, [cart?.meta?.EUROBONUS_NUMBER]);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();

    if (
      cart?.meta?.EUROBONUS_NUMBER &&
      cart?.meta?.EUROBONUS_NUMBER.length > 0
    ) {
      return handleClear();
    }

    const response = await updateCartMetadata({ eurobonusNumber }, true);

    if (response && inputRef.current) {
      inputRef.current.blur();
    }
  }

  async function handleClear() {
    const response = await updateCartMetadata({ eurobonusNumber: " " }, true);

    if (response) {
      setEurobonusNumber("");
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
  }

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    setEurobonusNumber(event.target.value);
  }

  return {
    inputRef,
    eurobonusNumber,
    isValidEurobonusNumber,
    handleClear,
    handleChange,
    handleSubmit,
  };
}
